import React from 'react'
import { Box, Card, CardContent, Grid, Skeleton, Typography } from '@mui/material'
import {
    TrendingUp,
    TrendingDown,
    AccountBalanceWallet,
    CheckCircleOutline,
    PendingOutlined,
    FormatListNumbered,
} from '@mui/icons-material'

const currencyBRL = (n) =>
    (Number(n) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

const kpiItems = [
    {
        key: 'income',
        label: 'Entradas',
        icon: TrendingUp,
        color: '#22C55E',
        format: 'currency',
    },
    {
        key: 'expense',
        label: 'Saídas',
        icon: TrendingDown,
        color: '#EF4444',
        format: 'currency',
    },
    {
        key: 'balance',
        label: 'Saldo',
        icon: AccountBalanceWallet,
        color: '#3B82F6',
        format: 'currency',
    },
    {
        key: 'total',
        label: 'Total',
        icon: FormatListNumbered,
        color: '#8B5CF6',
        format: 'number',
    },
    {
        key: 'reconciled',
        label: 'Conciliados',
        icon: CheckCircleOutline,
        color: '#22C55E',
        format: 'number',
    },
    {
        key: 'pending',
        label: 'Pendentes',
        icon: PendingOutlined,
        color: '#F59E0B',
        format: 'number',
    },
]

const SummaryBar = ({ summary }) => {
    if (!summary) {
        return (
            <Grid container spacing={2} sx={{ mb: 3 }}>
                {kpiItems.map((item) => (
                    <Grid item xs={6} sm={4} md={2} key={item.key}>
                        <Skeleton variant="rounded" height={80} />
                    </Grid>
                ))}
            </Grid>
        )
    }

    return (
        <Grid container spacing={2} sx={{ mb: 3 }}>
            {kpiItems.map((item) => {
                const Icon = item.icon
                const value = summary[item.key]
                return (
                    <Grid item xs={6} sm={4} md={2} key={item.key}>
                        <Card
                            sx={{
                                border: '1px solid #E2E8F0',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                                borderRadius: 2,
                            }}
                        >
                            <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                                <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                                    <Icon sx={{ fontSize: 18, color: item.color }} />
                                    <Typography
                                        variant="caption"
                                        sx={{ color: '#94A3B8', fontWeight: 600, textTransform: 'uppercase', fontSize: '0.65rem', letterSpacing: '0.05em' }}
                                    >
                                        {item.label}
                                    </Typography>
                                </Box>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: 700,
                                        color: item.key === 'balance'
                                            ? (value >= 0 ? '#1E293B' : '#EF4444')
                                            : '#1E293B',
                                        fontSize: '1rem',
                                    }}
                                >
                                    {item.format === 'currency'
                                        ? currencyBRL(value)
                                        : (value ?? 0)}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                )
            })}
        </Grid>
    )
}

export default SummaryBar
